<ng-template #menuModal let-modal>
  <form [formGroup]="formGroup" *ngIf="!isInvalidCategory">
    <div class="modal-body">
      <div class="data-showcase-grid">
        <h4 class="grid-title with-count s-bottom">Menu <span class="count">({{menuCount}} dishes)</span></h4>
        <div class="edit-food-menu-wrap">
          <div class="row">
            <div class="col-md-8 order-1 order-md-0">
              <div class="row" ngbAutofocus>
                <div class="col-12">
                  <app-input [inputType]="'text'" [fieldText]="'Title'" [fControl]="formGroup.controls['Title']"
                             [inputClass]="'form-control'" [inputPlaceholder]="'Enter Title'" [inputLabel]="'Title'"
                             [labelClass]="'data-label'"></app-input>
                </div>
                <div class="col-8 col-sm-7">
                  <app-select [options]="types" [selectClass]="'ng-form-select primary-select'" [isAddTag]="true"
                              selectPlaceholder="Select Type" label="Type" [(selectedValue)]="typeSelect"></app-select>
                </div>
                <div class="col-4 col-sm-5">
                  <app-input [inputType]="'text'" appNumbersOnly [fieldText]="'Price'"
                             [fControl]="formGroup.controls['Price']" [inputClass]="'form-control'"
                             [inputPlaceholder]="'Enter Price'" [inputLabel]="'Price'" [labelClass]="'data-label'"></app-input>
                </div>
                <div class="col-12">
                  <app-textarea [labelClass]="'data-label'"
                                [textAreaClass]="'form-control text-dark fw-normal fst-italic'"
                                [fControl]="formGroup.controls['Description']" [textAreaLabel]="'Description'"
                                [fieldText]="'description'" [isRequired]="false"></app-textarea>

                </div>
              </div>
            </div>
            <div class="col-md-4 order-md-1">
              <div class="file-upload-wrap">
                <input type="file" #fileInput accept="image/*" (change)="onFileSelected($event)">
                <div class="upload-inner" *ngIf="!foodPreviewAdded">
                  <img src="./assets/images/ic-add-light.svg" (click)="fileInput.click()" alt="Add Icon"
                       class="add-icon">
                  <span>ADD PHOTO</span>
                </div>
                <img [src]="foodPreviewUrl ? foodPreviewUrl:''" alt="Food" class="food-preview"
                     *ngIf="foodPreviewAdded">
              </div>
              <div class="file-upload-cta">
                <app-button [btnText]="'Delete'" [btnTitle]="'Delete'" [btnCss]="'btn btn-primary btn-sm'"
                            (onBtnClick)="deleteImage()"></app-button>

              </div>
            </div>
          </div>
          <div class="btn-grps">
            <app-button [btnText]="'Cancel'" [btnTitle]="'Cancel'" [btnCss]="'btn btn-outline-primary'"
                        (onBtnClick)="modal.close('Close click');resetForm();"></app-button>
            <app-button [btnText]="'Save'" [btnTitle]="'Save'" [btnCss]="'btn btn-primary'"
                        (onBtnClick)="addDish(id);"></app-button>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="modal-body text-muted" *ngIf="isInvalidCategory">
    <div class="data-showcase-grid">
      <div class="edit-food-menu-wrap">
        <div class="row">
          <p class="fs-17">HUNGERY is build to keep it simple for users to understand our listings, so we are limiting our categories to only 5.</p>
          <p class="mt-4 fs-17">
            But if you would like to keep your category data for future POS use, please map them to our categories so it will be
            displayed properly:
          </p>

          <div class="mt-4">
            <div class="fw-bold">CATEGORY MAPPING</div>
            <div class="card mt-2">
              <div class="card-body auto-scroll-vertical">
                <div>
                  <div class="row g-2">
                    <div class="col-12 col-md-6 text-muted fw-bold">
                      Your Category
                    </div>
                    <div class="col-12 col-md-6 text-muted fw-bold">Mapped Category</div>
                    <div *ngFor="let category of categoryMapping" class="row g-2">
                      <div class="col-12 col-md-6">
                        <input type="text" class="form-control" value={{category.yourCategory}} readonly />
                      </div>
                      <div class="col-12 col-md-6">
                        <app-select [options]="types" [selectClass]="'ng-form-select primary-select'"
                                    selectPlaceholder="Select Type" [(selectedValue)]="category.mappedCategory"></app-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-grps">
          <app-button [btnText]="'Cancel'" [btnTitle]="'Cancel'" [btnCss]="'btn btn-outline-primary'"
                      (onBtnClick)="isInvalidCategory=!isInvalidCategory"></app-button>
          <app-button [btnText]="'Save'" [btnTitle]="'Save'" [btnCss]="'btn btn-primary'"
                      (onBtnClick)="confirmMapping(id);!formGroup.invalid && modal.close('Close click');"></app-button>
        </div>
      </div>
    </div>
  </div>
</ng-template>
